import { jsx as _jsx } from "react/jsx-runtime";
import { Item, Section } from '@react-stately/collections';
import { isOptionGroup } from '../helper';
export const isArrayOfOptionGroup = (options) => options.some(item => isOptionGroup(item));
export const getActiveItem = (optionsOrOptionGroups, activeOption) => {
    return (optionsOrOptionGroups
        .flatMap(item => item.options || item)
        .find(option => option.value === activeOption) || null);
};
const isSelectOption = (option) => {
    return option.value !== undefined;
};
// the items are generated by mapping over the internal collection that’s passed in via the state.
// this means that we are not able to access each item as we normally would when mapping over the original items array.
// As key is the only prop we can access via the state - that was originally set in the mapToAriaProps method -
// `getKeyItemRecord` function is used as solution to access the original item via the key.
// check https://uxdesign.cc/how-to-build-an-accessible-dropdown-using-react-aria-8637971bbea9
export const getKeyItemRecord = (options) => {
    const obj = {};
    const assignToObj = (item, index) => {
        const key = `${item.label}-${index}`;
        obj[key] = item;
    };
    options.forEach((item, index) => {
        if (isSelectOption(item))
            assignToObj(item, index);
        else
            item.options.forEach(assignToObj);
    });
    return obj;
};
//  <Item> and <Section> only define the data for the items and sections,
//  not the rendering, visual appearance, or behavior.
//  check https://react-spectrum.adobe.com/react-stately/collections.html
const getItemsOrSections = (options) => {
    return options.map((option, index) => {
        if (isOptionGroup(option)) {
            return (_jsx(Section, { title: option.label, children: option.options.map((menuItem, innerIndex) => (
                // eslint-disable-next-line react/no-array-index-key -- fine here
                _jsx(Item, { textValue: menuItem.label, children: menuItem.label }, `${menuItem.label}-${innerIndex}`))) }, option.label));
        }
        return (
        // eslint-disable-next-line react/no-array-index-key -- fine here
        _jsx(Item, { textValue: option.label, children: option.label }, `${option.label}-${index}`));
    });
};
// Since the useSelectState and useSelect hooks expect menu options as children,
// we need to map SelectOptionGroup[] array to an object with children.
// Also, Set the ariaLabel for the Dropdown and the sections.
// Adding aria-label to void console warning
// check docs https://react-spectrum.adobe.com/react-aria/accessibility.html#labeling
export const mapToAriaProps = (options, ariaLabel, ariaLabelledBy, label) => ({
    label,
    'aria-label': label ? undefined : ariaLabel,
    'aria-labelledby': label || ariaLabel ? undefined : ariaLabelledBy,
    children: getItemsOrSections(options),
});
